/* eslint-disable */

/**
 * A mapping between the CSS class that enforces brand/tenant-specific styles in an authenticated session
 * and the tenant ID.
 */
export enum Brand {
  // addProtect = 0,
  // bankinter = 1,
  // bcn = 1,
  // ficohsa = 1,
  // 'hsbc-uk' = 1,
  // nkb = 1,
  bbva = 1,
  // postfinance = 1,
  // sgkb = 1,
  // ukb = 1,
  // wir = 1,
  glkb = 2,
}